import { Trans } from 'react-i18next'
import i18n from 'i18next'
import { getFullUrlToSsr } from 'utils/router'
import { PRODUCT_LIST } from 'common/constants/ProductConstants'

export const ONE_TIME_PROJECT_DESCRIPTION = {
    [PRODUCT_LIST.OneTimeWhitelabel]: i18n.t('Your branding and up to 10,000 leads per month.'),
    [PRODUCT_LIST.OneTimeGamification]: i18n.t(
        'Turn on the rating of players and arrange a prize draw. Suitable for small events',
    ),
    [PRODUCT_LIST.OneTimeEvent]: i18n.t('Advanced plan for medium and large events.'),
}

export const ONE_TIME_PROJECT_CORRESPONDS = {
    [PRODUCT_LIST.OneTimeWhitelabel]: (
        <Trans
            i18nKey="Corresponds to the <a>{{tariff}}</a> plan"
            values={{
                tariff: 'PRO',
            }}
            components={{
                a: <a href={getFullUrlToSsr('/pricing/business?group=business')} target="_blank" />,
            }}
        />
    ),
    [PRODUCT_LIST.OneTimeGamification]: (
        <Trans
            i18nKey="Corresponds to the <a>{{tariff}}</a> plan"
            values={{
                tariff: 'PRO+',
            }}
            components={{
                a: <a href={getFullUrlToSsr('/pricing/business?group=business')} target="_blank" />,
            }}
        />
    ),
    [PRODUCT_LIST.OneTimeEvent]: (
        <Trans
            i18nKey="Corresponds to the <a>{{tariff}}</a> plan"
            values={{
                tariff: 'Teams',
            }}
            components={{
                a: <a href={getFullUrlToSsr('/pricing/business?group=business')} target="_blank" />,
            }}
        />
    ),
}
